import React from 'react';
import { Container } from 'react-bootstrap';
import mypgImg from '../Images/mypg356.png';
import hogImg from '../Images/hog.png';
import rdpImg from '../Images/rdp.jpg';

const Portfolio = () => {
  return (
    <Container id="portfolio">
      <h2 className="header-clr">Portfolio</h2>
      <div className="divider"></div>
      <br />
      <p>
        A selection of full-stack web platforms, machine learning systems, and network communication applications engineered from scratch.
      </p>
      <br />

      <div className="card-main">
        {/* Project 1 */}
        <div className="card-1">
          <div className="card">
            <img src={mypgImg} className="card-img-top" alt="MYPG356 Platform" />
            <div className="card-body">
              <h5 className="card-title">MYPG356 – Rental Marketplace</h5>
              <p className="card-text">
                Full-stack PG marketplace built with React, Node, Express, MongoDB, and Redis caching (reducing query latency by 40%), featuring JWT authentication and owner dashboards.
              </p>
              <div className="card-buttons">
                <a href="https://mypg365.com" rel="noreferrer" target="_blank" className="btn btn-primary">
                  Visit
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Project 2 */}
        <div className="card-2">
          <div className="card">
            <img src={hogImg} className="card-img-top" alt="Attendance Tracker" />
            <div className="card-body">
              <h5 className="card-title">Face Recognition Attendance Tracker</h5>
              <p className="card-text">
                Automated attendance tracking system built with Python, OpenCV, and dlib (98% accuracy), logging records in real time and eliminating manual overhead.
              </p>
              <div className="card-buttons">
                <a href="https://github.com/BABU-BALAJI-V/AttendanceTracker" rel="noreferrer" target="_blank" className="btn btn-primary">
                  GitHub
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Project 3 */}
        <div className="card-3">
          <div className="card">
            <img src={rdpImg} className="card-img-top" alt="Remote Desktop Protocol" />
            <div className="card-body">
              <h5 className="card-title">Remote Desktop Protocol (RDP)</h5>
              <p className="card-text">
                Java-based client-server RDP application utilizing socket programming, TCP/IP networking, multithreading, and a Java Swing GUI for low-latency desktop control.
              </p>
              <div className="card-buttons">
                <a href="https://github.com/BABU-BALAJI-V/final" rel="noreferrer" target="_blank" className="btn btn-primary">
                  GitHub
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Portfolio;